/* AccountHelp auto-generated by npm run generator */
import { Button } from "@material-ui/core"
import PortalForm from "components/molecules/PortalForm"
import { observer } from "mobx-react"
import React from "react"
import { Link as RouterLink } from "react-router-dom"
import { PATHS } from "Router"

interface AccountHelpProps {}

const AccountHelp: React.FC<AccountHelpProps> = (props) => {
    return (
        <PortalForm
            title={"Account Help"}
            subtitle={"What would like help with?"}
            form={<></>}
            buttons={
                <>
                    <Button component={RouterLink} to={PATHS.RESET()}>
                        Reset Password
                    </Button>
                    <Button component={RouterLink} to={PATHS.NEW_USER()}>
                        Resend Invite
                    </Button>
                </>
            }
            buttonAction={async () => {}}
        />
    )
}

export default observer(AccountHelp)
